// extracted by mini-css-extract-plugin
export var searchHeader = "_a8-0";
export var searchHeaderDark = "_a8-1";